import * as S from './styles'

/**
 * Grade de rótulo e valor dos painéis de campanha, na forma que o desenho do
 * offsite estabelece: três colunas, rótulo acima do valor, sem borda entre
 * células — `apps/offsite/v2.html`, regra `.review-info-grid`.
 *
 * Nasceu no `BriefingRows`, que a usava só no cartão do aprovador, e saiu de lá
 * quando o `InfoView` precisou da mesma leitura. Mora em `src/components`
 * porque não é de retail media: é a forma de ler par de termo e definição.
 *
 * Só apresentação. Quem decide quais campos existem, e sob qual condição, é
 * quem chama.
 */
export const DefinitionGrid = ({
  children,
  className
}: DefinitionGridProps) => <S.Grid className={className}>{children}</S.Grid>

/**
 * Uma célula da grade, como `dl/dt/dd`: é par de termo e definição, não ênfase
 * de texto, e é o que dá a relação a quem usa leitor de tela.
 */
export const DefinitionItem = ({
  label,
  children,
  wide,
  className
}: DefinitionItemProps) => (
  <S.Item $wide={wide} className={className}>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </S.Item>
)
